import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatFileSize'
})
export class FormatFileSize implements PipeTransform {
  transform(value: string): string {

    const size = 1024;
    let num: number = Number(value);

    if(num === 0 || num == null) return " 0 Bytes ";

    if(num < 1){
      let kb: number = num * size;

      if(kb < 1){
        return (kb * size).toFixed(0) + " Bytes ";

      }else{
        return kb.toFixed(2) + " KB ";
      }

    }else if(num >= 1000){
      let gb: number = num/size;
      return gb.toFixed(2) + " GB ";

    }else{
      return num.toFixed(2) + " MB ";
    }
  }
}